import { createPrefetchableAsyncPaginatedDataContext, pageDataErrorHandler } from 'src/app/shared/contexts/asyncData';

import { getFirstPageData, getNextPageData } from './api';
import type { DecisionMakerPageDataErrorCode } from './types';

export const {
	Context: DMProfilePagePaginatedResponsesDataContext,
	Provider: DMProfilePagePaginatedResponsesDataContextProvider,
	useContext: useDMProfilePagePaginatedResponsesData,
	useAsyncData: useDMProfilePagePaginatedResponsesDataFromApi,
	prefetchAsyncData: prefetchDMProfilePagePaginatedResponsesDataFromApi,
} = createPrefetchableAsyncPaginatedDataContext({
	name: 'DMProfilePagePaginatedResponsesDataContext',
	dataProperty: 'responsesPaginatedData',
	getFirstPageData,
	getNextPageData,
	getUniqueId: (slug, { countryCode, locale }) => [slug, countryCode, locale].join(':'),
	hookDeps: (slug, { countryCode, locale }) => [slug, countryCode, locale],
	errorHandler: pageDataErrorHandler<DecisionMakerPageDataErrorCode>(),
});
